<template>
    <section class="bg-[#17364a] py-20">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-[#1e4d63]">
                <div
                    v-for="stat in stats"
                    :key="stat.id"
                    class="flex flex-col items-center justify-center py-12 sm:py-16 px-8 text-center"
                >
                    <dd class="text-6xl sm:text-7xl font-extrabold text-[#A07830] tracking-tight tabular-nums">{{ stat.value }}</dd>
                    <dt class="mt-3 text-sm font-medium uppercase tracking-widest text-gray-500">{{ stat.name }}</dt>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const stats = [
    { id: 0, name: 'Students Enrolled', value: '1M+' },
    { id: 1, name: 'Courses Available', value: '500+' },
    { id: 3, name: 'Languages Supported', value: '5' },
]
</script>
